import RegisterButton from './RegisterButton'

export default RegisterButton
